/* eslint-disable */
// Imported from:
// https://github.com/forkphorus/forkphorus/tree/master/FeaturedProjects
// With changes to make it work properly in the scratch-gui environment.
// todo: we have to see if we are leaking memory when this is mounted and unmounted, esp. because of event listeners
// todo: use react-intl for translations

import styles from './featured-projects.css';
import classNames from 'classnames';

/**
 * @class
 */
var FeaturedProjects = function () {
    this.offset = 0;
    this.ended = false;
    this.loadingPage = false;
    this.unusedPlaceholders = [];

    this.root = document.createElement('div');
    this.root.className = styles.featuredProjectsRoot;
    this.projectList = document.createElement('div');
    this.projectList.className = styles.featuredProjectsList;
    this.root.appendChild(this.projectList);

    if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver(this.handleIntersection.bind(this), {
            root: this.projectList
        });
        this.loadNextPageObserver = new IntersectionObserver(this.handleLoadNextPageIntersection.bind(this), {
            root: this.projectList
        });
    } else {
        this.intersectionObserver = null;
        this.loadNextPageObserver = null;
    }

    // will be filled in by featured-projects-view.jsx
    this.messages = {
        AUTHOR_ATTRIBUTION: '',
        PROJECT_HOVER_TEXT: '',
        LOAD_ERROR: ''
    };
};

/**
 * Add a project to the view.
 * An unused placeholder element may be used, or it may be created.
 */
FeaturedProjects.prototype.addProject = function (details) {
    var el;
    if (this.unusedPlaceholders.length) {
        el = this.unusedPlaceholders.shift();
    } else {
        el = this.createPlaceholder();
        this.projectList.appendChild(el);
    }
    this.placeholderToProject(el, details.id, details.title, details.thumbnailId, details.authorName);
};

/**
 * Create an <img> element that will load only when it becomes visible.
 */
FeaturedProjects.prototype.createLazyImage = function (src) {
    var el = document.createElement('img');
    if (this.intersectionObserver) {
        this.intersectionObserver.observe(el);
        el.dataset.src = src;
    } else {
        // then we just won't lazy load it
        el.src = src;
    }
    return el;
};

/**
 * Create a placeholder or placeholder element.
 */
FeaturedProjects.prototype.createPlaceholder = function () {
    var el = document.createElement('a');
    el.className = classNames(styles.featuredProjectsProject, styles.featuredProjectsPlaceholder);

    var thumbnail = document.createElement('div');
    thumbnail.className = styles.featuredProjectsThumbnail;

    var title = document.createElement('div');
    title.className = styles.featuredProjectsTitle;

    var author = document.createElement('div');
    author.className = styles.featuredProjectsAuthor;

    el.thumbnailEl = thumbnail;
    el.titleEl = title;
    el.authorEl = author;

    el.appendChild(thumbnail);
    el.appendChild(title);
    el.appendChild(author);

    return el;
};

/**
 * Convert a placeholder element made by createPlaceholder to a project element.
 */
FeaturedProjects.prototype.placeholderToProject = function (el, id, title, thumbnailId, author) {
    el.className = classNames(styles.featuredProjectsProject, styles.featuredProjectsLoaded);
    el.dataset.id = id;
    el.dataset.title = title;
    el.dataset.thumbnailId = thumbnailId;
    el.dataset.author = author;
    el.title = this.messages.PROJECT_HOVER_TEXT.replace('$author', author).replace('$title', title);
    el.href = FeaturedProjects.PROJECT_PAGE.replace('$id', id);

    var thumbnailSrc = FeaturedProjects.THUMBNAIL_SRC.replace('$id', thumbnailId);
    var thumbnailImg = this.createLazyImage(thumbnailSrc);
    el.thumbnailEl.appendChild(thumbnailImg);

    el.titleEl.innerText = title;
    el.authorEl.innerText = this.messages.AUTHOR_ATTRIBUTION.replace('$author', author);

    el.addEventListener('click', this.handleClick.bind(this), true);
    el.addEventListener('keydown', this.handleKeyDown.bind(this), true);

    return el;
};

/**
 * Adds an error message to the list.
 */
FeaturedProjects.prototype.addErrorElement = function () {
    var el = document.createElement('div');
    el.innerText = this.messages.LOAD_ERROR;
    el.className = styles.featuredProjectsError;
    this.projectList.appendChild(el);
};

FeaturedProjects.prototype.handleLoadNextPageIntersection = function (e) {
    for (var i = 0; i < e.length; i++) {
        var intersection = e[i];
        if (intersection.isIntersecting && this.canLoadNext()) {
            this.loadNextPage();
        }
    }
};

// Click a project element or a child of a project element
FeaturedProjects.prototype.clickProject = function (el) {
    while (!el.classList.contains(styles.featuredProjectsProject)) {
        el = el.parentNode;
    }
    var id = el.dataset.id;
    this.onselect(id, el);
}

// Called when click is fired on a project element
FeaturedProjects.prototype.handleClick = function (e) {
    e.preventDefault();
    this.clickProject(e.target);
};

// Called when keydown is fired on a project element
FeaturedProjects.prototype.handleKeyDown = function (e) {
    if (e.keyCode === 13) {
        // treat enter (13) as click
        e.preventDefault();
        this.clickProject(e.target);
    }
};

// Called by the IntersectionObserver when it sees an intersection
FeaturedProjects.prototype.handleIntersection = function (entries, observer) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            var target = entry.target;
            target.src = target.dataset.src;
            target.dataset.src = '';
            target.className = '';
            observer.unobserve(target);
        }
    });
};

/**
 * Determines whether it is safe to attempt to load the next page.
 */
FeaturedProjects.prototype.canLoadNext = function () {
    return !this.loadingPage && !this.ended;
};

/**
 * Remove all unused placeholder elements.
 */
FeaturedProjects.prototype.cleanupPlaceholders = function () {
    while (this.unusedPlaceholders.length) {
        var el = this.unusedPlaceholders.pop();
        this.projectList.removeChild(el);
    }
};

/**
 * Add placeholder placeholder elements.
 */
FeaturedProjects.prototype.addPlaceholders = function () {
    for (var i = 0; i < FeaturedProjects.PLACEHOLDER_COUNT; i++) {
        var el = this.createPlaceholder();
        this.unusedPlaceholders.push(el);
        this.projectList.appendChild(el);
    }
};

/**
 * Make changes to the order of projects.
 * Default shuffler does nothing.
 */
FeaturedProjects.prototype.shuffler = function (projects) {
    return projects;
};

/**
 * Begins loading the next page.
 */
FeaturedProjects.prototype.loadNextPage = function () {
    if (this.loadingPage) {
        throw new Error('Already loading the next page');
    }
    if (this.ended) {
        throw new Error('There are no more pages to load');
    }

    if (this.unusedPlaceholders.length === 0) {
        this.addPlaceholders();
    }
    if (this.loadNextPageObserver) {
        this.loadNextPageObserver.disconnect();
    }
    this.root.setAttribute('loading', '');
    this.loadingPage = true;

    var xhr = new XMLHttpRequest();
    xhr.responseType = 'json';
    xhr.onload = function () {
        var rawProjects = xhr.response?.projects;
        if (!Array.isArray(rawProjects)) {
            xhr.onerror();
            return;
        }
        var projects = [];
        for (var i = 0; i < rawProjects.length; i++) {
            var p = rawProjects[i];
            projects.push({
                id: p.id,
                title: p.name,
                thumbnailId: p.thumbnailId || 1,
                authorId: p.author.id, // TODO: add username hyperlink to author's profile
                authorName: p.author.username
            });
        }
        projects = this.shuffler(projects);
        for (var i = 0; i < projects.length; i++) {
            this.addProject(projects[i]);
        }
        this.cleanupPlaceholders();

        if (rawProjects.length === 40) {
            if (this.loadNextPageObserver) {
                this.loadNextPageObserver.observe(this.projectList.lastChild);
            }
        } else {
            this.ended = true;
            this.onend();
        }

        this.offset += projects.length;
        this.loadingPage = false;
        this.root.removeAttribute('loading');

        this.onpageload();
    }.bind(this);

    xhr.onerror = function () {
        this.root.setAttribute('error', '');
        this.cleanupPlaceholders();
        this.addErrorElement();
        this.ended = true;
    }.bind(this);

    var url = FeaturedProjects.FEATURED_API
        // TODO: .replace('$offset', '' + this.offset);
    xhr.open('GET', url);
    xhr.send();
};

FeaturedProjects.prototype.onselect = function (id, el) { };
FeaturedProjects.prototype.onpageload = function () { };
FeaturedProjects.prototype.onend = function () { };

FeaturedProjects.FEATURED_API = 'https://dashblocks-server.vercel.app/featured-projects';

// The URL to download thumbnails from.
// $id is replaced with the project's ID.
FeaturedProjects.THUMBNAIL_SRC = 'https://dashblocks-server.vercel.app/projects/thumbnails/$id';

// The URL for project pages.
// $id is replaced with the project ID.
FeaturedProjects.PROJECT_PAGE = 'https://dashblocks.github.io/#$id';

// The amount of "placeholders" to insert before the next page loads.
FeaturedProjects.PLACEHOLDER_COUNT = 9;

export default FeaturedProjects;
